"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _attachThemeAttrs = _interopRequireDefault(require("../../../styles/helpers/attachThemeAttrs"));

var _color = require("../../../styles/helpers/color");

var _borderRadius = require("../../../styles/borderRadius");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: ", ";\n    border: solid 1px ", ";\n    background-color: ", ";\n    line-height: 2.5rem;\n    height: 2.5rem;\n\n    > :first-child {\n        margin-left: -1px;\n    }\n\n    > :last-child {\n        margin-right: -2px;\n    }\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButtonItemsContainer = (0, _attachThemeAttrs["default"])(_styledComponents["default"].div)(_templateObject(), _borderRadius.BORDER_RADIUS_2, function (props) {
  return props.palette.border.divider;
}, function (props) {
  return (0, _color.replaceAlpha)(props.palette.background.highlight, 0.4);
}, function (props) {
  return props.variant === 'inverse' && "\n            border-color: rgba(0, 0, 0, 0.4);\n            background-color: rgba(0, 0, 0, 0.4);\n        ";
});
var _default = StyledButtonItemsContainer;
exports["default"] = _default;